import SidebarBookingsLogsController from 'uplisting-frontend/pods/-sidebar/bookings/logs/controller';

export default class ProtectionOverviewBookingsLogsController extends SidebarBookingsLogsController {}
